
    <spaq-layout-account>
      <spaq-dashboard></spaq-dashboard>
    </spaq-layout-account>
  


// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/account/dashboard/containers/dashboard-page.component.ts.DashboardPageComponent.html